import { useApplications } from "@/services/OvhService";
import { useEffect, useState } from "react";
import { Button, Container, Grid, Typography } from "@mui/material";
import Filter from "@/components/Filter";
import { GridData } from "@/components/GridData";
import { Application } from "@/types/webservices_ovh_db.types";
import { FieldColumn } from "@/types/others.types";
import {
  ApplicationFilters,
  FiltersTypes,
} from "@/types/webservices_filters.types";
import { CobaltIcon } from "@docaposte-agility/da-design-system";

const Applications = () => {
  const [filteredApplications, setFilteredApplications] = useState<
    Array<Application>
  >([]);
  const [filters, setFilters] = useState<ApplicationFilters>(() => {
    return columns.reduce(
      (acc, { field }) => ({ ...acc, [field]: "" }),
      {},
    ) as ApplicationFilters;
  });

  const {
    applications,
    refetch: refetchApplications,
    isLoading: isLoadingApplications,
  } = useApplications({
    onSuccess: (data) => {
      filter(data.data);
    },
  });

  useEffect(() => {
    filter(applications);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const filter = (applications: Application[]) => {
    let filterResults: Array<Application> = applications;
    if (filterResults) {
      Object.entries(filters).forEach(([key, filter]: Array<any>) => {
        if (filter) {
          filterResults = filterResults.filter((application: Application) =>
            application[key].includes(filter),
          );
        }
      });
    }
    setFilteredApplications(filterResults);
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        margin: "1.5rem",
        height: "fit-content",
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: "16px" }}
      >
        <Grid item>
          <Typography
            variant="h1"
            color="cobalt.bleuDigital100"
            sx={{ textAlign: "center", fontSize: "32px" }}
          >
            Applications
          </Typography>
        </Grid>
        <Grid item sx={{ height: "24px" }}>
          <Button
            startIcon={<CobaltIcon name="refresh-cw" />}
            onClick={() => refetchApplications()}
            variant="text"
            sx={{ height: "24px", pt: 0, pb: 0 }}
          >
            Recharger
          </Button>
        </Grid>
      </Grid>
      <Filter
        fields={columns}
        filters={filters}
        setFilters={setFilters as (filters: FiltersTypes) => void}
      />
      <GridData
        rows={filteredApplications || []}
        columns={columns}
        loading={isLoadingApplications}
      />
    </Container>
  );
};

const columns: Array<FieldColumn> = [
  {
    field: "name",
    headerName: "Nom",
    flex: 310,
    headerAlign: "center",
    filter: true,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 350,
    filter: true,
    headerAlign: "center",
  },
  {
    field: "applicationId",
    headerName: "Application ID",
    flex: 150,
    headerAlign: "center",
    filter: true,
  },
  {
    field: "applicationKey",
    headerName: "Application key",
    flex: 240,
    headerAlign: "center",
    filter: true,
  },
  {
    field: "ovhAccount",
    headerName: "Compte OVH",
    flex: 190,
    headerAlign: "center",
    filter: true,
  },
  {
    field: "state",
    headerName: "Status",
    flex: 170,
    headerAlign: "center",
    filter: true,
  },
];

export default Applications;
